import CombinedStyleSheet from "../internal/CombinedStyleSheet";
import suffixProperties from "../internal/suffixProperties";
import humanTall from "./humanTall";
import systemTallWeights from "../helpers/systemTallWeights";

// Extracted from the sketch file
// https://developer.apple.com/design/resources/
// These are the textStyles that fall under the category of iOS UIKit

const getStylesForColor = color => {
  const colorSuffix = color === "white" ? "White" : "";
  return {
    largeTitleEmphasized: {
      ...humanTall[`largeTitle${colorSuffix}Object`],
      ...systemTallWeights.bold,
      letterSpacing: 0.41
    },
    title3: humanTall[`title3${colorSuffix}Object`],
    title3Emphasized: {
      ...humanTall[`title3${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      letterSpacing: 0.75
    },
    body: humanTall[`body${colorSuffix}Object`],
    bodyEmphasized: {
      ...humanTall[`body${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      letterSpacing: -0.41
    },
    subhead: humanTall[`subhead${colorSuffix}Object`],
    subheadShort: {
      ...humanTall[`subhead${colorSuffix}Object`],
      lineHeight: '23px'
    },
    subheadEmphasized: {
      ...humanTall[`subhead${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      letterSpacing: -0.24
    },
    callout: humanTall[`callout${colorSuffix}Object`],
    footnote: humanTall[`footnote${colorSuffix}Object`],
    footnoteEmphasized: {
      ...humanTall[`footnote${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      letterSpacing: -0.08
    },
    caption2: humanTall[`caption2${colorSuffix}Object`],
    caption2Emphasized: {
      ...humanTall[`caption2${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      letterSpacing: 0.06
    }
  };
};

export default CombinedStyleSheet.create({
  ...getStylesForColor("black"),
  ...suffixProperties(getStylesForColor("white"), "White")
});